module.exports = __webpack_public_path__ + "static/media/AwaitingParts.2b799f29.svg";